export class DeviceProfileSetting {
  constructor(
    public settingKey: string,
    public settingValue: any,
    public id?: number,
    public liteserverId?: number
  ) {
    if (this.settingValue === 'true' || this.settingValue === 'false') {
      this.settingValue = this.settingValue === 'true';
    } else {
      try {
        this.settingValue = JSON.parse(this.settingValue);
      } catch (e) {}
    }
  }
}
